export default "__VITE_ASSET__f54107e5__"